const getFromSchema = (schema, value) => schema.parse(value);

export { getFromSchema };
